import { Link } from "react-router-dom";
import "./Careers.css";

const Careers = () => {
  return (
    <div>
      <div className="career_container">
        <div className="careerp_div2 ">
          <div className="careerp_div21  ">
            <h2>
              Join a team where we <br className="award_br" /> create delight through connected <br className="award_br"/> experiences
            </h2>
            <p>
              Would you be interested in joining us on a journey where one of
              the common factors is delivering value to all stakeholders and
              building a rewarding career for yourself?
            </p>
            <p>Empower Your Future with Us, powered by our people.</p>
            <span>Connect with us at <a href="mailto:careers@crestdigitel.com">careers@crestdigitel.com</a></span>
          </div>
          <div className="careerp_div31">
            <img src="/assets/careers/Careers.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
